import { render, staticRenderFns } from "./AppGlobalSidebarItemDropdown.vue?vue&type=template&id=4aeaf904&"
import script from "./AppGlobalSidebarItemDropdown.vue?vue&type=script&lang=js&"
export * from "./AppGlobalSidebarItemDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports